export default __webpack_public_path__ + "static/media/2_2.be444c7e.png";